const VALID_URL_REGEX = /^https?:\/\/\w+/i;

export const isValidHttpUrl = (url: string) => VALID_URL_REGEX.test(url);
